import styled, { css } from "styled-components";
import { borderRadius, fontSizes, lineHeights, spacing, typographyMixin } from "@magicbi/ui-library";

export const Grid = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: ${spacing[2]};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Cell = styled.li`
  min-width: 0;
  display: flex;
`;

const tileBase = css<{ $off: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing[2.5]};
  width: 100%;
  min-width: 0;
  padding: ${spacing[2.5]} ${spacing[3]};
  border: 1px solid ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius.md};
  background: ${({ $off, theme }) => ($off ? theme.colors.background.secondary : theme.colors.surface.primary)};
  color: ${({ $off, theme }) => ($off ? theme.colors.text.secondary : theme.colors.text.primary)};
  cursor: ${({ $off }) => ($off ? "not-allowed" : "pointer")};
  text-align: left;
  ${typographyMixin("caption", 3)}

  &:focus-visible,
  &:focus-within {
    outline: 2px solid ${({ theme }) => theme.colors.interactive.primary};
    outline-offset: 2px;
  }
`;

/** A real checkbox inside a label, so the whole tile toggles it. */
export const Tile = styled.label<{ $off: boolean }>`
  ${tileBase}
`;

export const Name = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${fontSizes["13"]};
  line-height: ${lineHeights["18"]};
  font-weight: 600;
`;

export const Note = styled.span`
  margin-left: auto;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: 400;
  white-space: nowrap;
`;

export const ShowAll = styled.button<{ $off: boolean }>`
  ${tileBase}
  justify-content: center;
  border-style: dashed;
  color: ${({ theme }) => theme.colors.text.link};
`;

/** GAP(accent fallback): the colour is data; without one the tile uses the neutral stroke. */
export const Initials = styled.span<{ $accent?: string; $size: number }>`
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}rem;
  height: ${({ $size }) => $size}rem;
  border-radius: ${borderRadius.sm};
  background: ${({ $accent, theme }) => $accent ?? theme.colors.text.tertiary};
  color: ${({ theme }) => theme.colors.text.inverse};
  font-size: ${({ $size }) => Math.max($size * 0.41, 0.5)}rem;
  font-weight: 700;
  line-height: 1;
`;

export const LogoImage = styled.img<{ $size: number }>`
  flex: none;
  width: ${({ $size }) => $size}rem;
  height: ${({ $size }) => $size}rem;
  border-radius: ${borderRadius.sm};
  object-fit: contain;
`;
